import React from 'react';
import { Link } from 'react-router-dom';

import { useAdminModeration } from '../context/AdminModerationContext';
import { AVATAR_PHOTO_CLASS } from './ui/avatar';
import { defaultPfpUrl } from './utils';

/**
 * In-app path for a user or organization profile.
 * @param {number} userId
 * @param {boolean} [isOrg]
 * @param {boolean} [adminPortal]
 * @returns {string}
 */
export function profilePath(userId, isOrg = false, adminPortal = false) {
    if (adminPortal) {
        return isOrg
            ? `/platform-admin/organizations/${userId}`
            : `/platform-admin/users/${userId}`;
    }
    return isOrg ? `/organization/${userId}` : `/profile/${userId}`;
}

/**
 * Link to a user or organization profile.
 * @param {Object} props
 * @param {number} props.userId
 * @param {boolean} [props.isOrg]
 * @param {React.ReactNode} [props.children]
 * @param {string} [props.className]
 * @param {boolean} [props.showProfilePic]
 * @param {string} [props.profilePicUrl]
 * @param {string} [props.profilePicSize]
 * @returns {JSX.Element}
 */
const UserLink = ({
    userId,
    isOrg = false,
    children,
    className = "",
    showProfilePic = false,
    profilePicUrl = "",
    profilePicSize = "w-12 h-12",
}) => {
    const moderation = useAdminModeration();

    if (!userId) {
        return <span className={className}>{children}</span>;
    }

    const to = profilePath(userId, isOrg, Boolean(moderation));

    return (
        <Link 
            to={to} 
            className={`hover:opacity-80 transition-opacity ${className}`}
        >
            {showProfilePic && profilePicUrl && (
                <img
                    src={profilePicUrl}
                    alt="Profile"
                    className={`${profilePicSize} rounded-full ${AVATAR_PHOTO_CLASS}`}
                    onError={(e) => {
                        e.target.src = defaultPfpUrl;
                    }}
                />
            )}
            {children}
        </Link>
    );
};

export default UserLink;
